require("SimpleBarJs")
require("SimpleBarCss")
require("../app/toggle_block.coffee")
require("../app/browser_detect.coffee")
require("../app/search_document.coffee")

window.pageInitStaticPageFlag = false

pageInit = ->
  new window.ToggleBlock()
  new window.SearchDocument()
  browserDetect = new window.BrowserDetect()

  if (browserDetect.browser == 'Explorer' && browserDetect.version < 11)
    $('.table-wrapper').each ->
      $(this).css('overflow','auto')
  else
    $('.table-wrapper').each ->
      new SimpleBar($(this)[0], { autoHide: false })


$(document).ready ->
  if window.pageInitStaticPageFlag != true
    pageInit()
  window.pageInitStaticPageFlag = true


// WEBPACK FOOTER //
// ./assets/javascripts/pages/static_page_2.coffee